/**
 * @Copyright 2014-2017 DataVoke, Inc. All rights reserved.
 */
define(['../appContext', './dvtypes', './dateLib', '../expressions'],
function (app, dvtypes, dateLib, expressions) {
    var expreng = {
        custom: {},             // This is an object placeholder to attach custom functions to...EK
        currexpression: {},     // A reference to the current expression object that is being evaluated (we do this so we have visibility to the vfp function - so that all functions in this library can evaluate)...AL
        expr: {}                // Holder object for all expression functions that are available...EK
    };

    /**
     * Returns a reference to the mvc object for the current Custom Function or Run JavaScript action.
     * Example (from Run JavaScript action): self().drivingView.Name --> returns the view's name.
     */
    function self() {
        return expreng.currexpression.mvc.apiRef;
    }

    /**
     * Registers an expression function with the expression engine so that it can be used in expressions
     * @param {Object} expression
     */
    expreng.register = function (expression) {
        if(expression.Execute) {
            expression.execute = expression.Execute;
        }

        if (typeof expression.execute !== 'string' && typeof expression.execute !== 'function') {
            console.error(`Expression ${expression.Metadata.Name} has no execute function`);
            return;
        }

        try {
            let name = expression.Metadata.Name.toLowerCase().trim();
            if(typeof expression.execute === 'string') {
                expression.execute = eval(`(${expression.execute})`);
            }
            // else it's already a function

            if(typeof expreng.expr[name] === 'function') {
                console.warn(`Overwriting duplicate expression function: ${name}`);
            }

            expression.execute.updatesOnData = expression.Metadata.UpdatesOnData;

            expreng.expr[name] = expression.execute;
        }
        catch(e) {
            console.error(`Error registering expression ${expression.Metadata.Name} : ${e.toString()}`);
        }
    };

    // Register core DataVoke expressions...AK
    for(let expression of Object.values(expressions)) {
        expression.execute.isCore = true;
        expreng.register(expression);
    }

    var list = null;            // internal reference for the purpose of property list generation ... EK
    // The actual evaluate function that the expression object invokes (so we have scope to both: the expression scope, and this library)...AL
    expreng.evaluate = function (ex) {
        expreng.currexpression = ex;
        list = [];
        try {
            var result;
            // if there is no formula, then return null.
            if (ex == null || ex.formula == null || ex.formula == "") { result = null; }
            else { result = eval(ex.formula); }

            expreng.currexpression = null;

            //List is a special variable that can be populated by the expression for DataType: List...BC/WR
            //If the list has items, return it instead of the result.
            if (list.length > 0) {
                for (var i = 0, il = list.length; i < il; i++) {
                    list[i] = list[i].toString();
                }
                return list;
            }

            return result;
        }
        catch (e) {
            expreng.currexpression = null;
            throw new Error("Expression Evaluation Error: " + e.message + "\n" +
                            "Formula: " + ex.formula);
        }
    };

    function operator_not(value) {
        return !value;
    }

    function operator_notequal(left, right) {
        return left != right;
    }

    function operator_or(left, right) {
        return left || right;
    }

    function operator_and(left, right) {
        return left && right;
    }

    function operator_notin() {
        return !operator_in(arguments);
    }

    function operator_in(target) {
        var arg;
        for (var i = 1; i < arguments.length; i++) {
            arg = arguments[i];
            // if an array, ensure we check in the array.
            if (Array.isArray(arg) == true) {
                if (arg.indexOf(target) > -1) {
                    return true; // Found in the array, return good news..
                }
            }
            else {
                if (target == arg) {
                    return true; // Found a true condition, return the good news...AL
                }
            }
        }

        return false; // No paramenters evaluate to true if we are here...AL
    }

    function operator_notlike(target, query) {
        return !operator_like(target, query);
    }

    function operator_like(target, query) {
        if (query == null) return false;
        if (target == null && query.length > 0) { return false; }

        //Remove string identifiers...EK
        if (query[0] === '"') {
            query = query.substring(1, query.length - 1);
        }

        if (query[query.length] === '"') {
            query = query.substring(0, query.length - 1);
        }

        //Clean the query of specials...EK
        query = query.replace(new RegExp("([\\.\\\\\\+\\*\\?\\[\\^\\]\\$\\(\\)\\{\\}\\=\\!\\<\\>\\|\\:\\-])", "g"), "\\$1");
        // Replace % and _ with equivalent regex (and test)...EK
        query = query.replace(/%/g, '.*').replace(/_/g, '.');
        return RegExp('^' + query + '$', 'gi').test(target);
    }

    return expreng;
});
